import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const style = {
  overflowY: 'auto',
  height: '300px',
};

const CommonModalComponent = ({
  children,
  showModal,
  toggleModal,
  modalHeader,
  modalSize = 'modal-lg',
}) => {
  return (
    <>
      <Modal
        isOpen={showModal}
        toggle={() => toggleModal()}
        backdrop="static"
        className={modalSize}
      >
        <ModalHeader toggle={() => toggleModal()} className="border-bottom">
          <strong>{modalHeader}</strong>
        </ModalHeader>
        <ModalBody className="modal-body">{children}</ModalBody>
      </Modal>
    </>
  );
};

export default CommonModalComponent;
